import { DeleteOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Row, Space, Tabs } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { Input } from 'antd/lib';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { ContentHeader } from "../../components";
import ModalTextForm from '../../components/modal/ModalTextForm';
import { trangThaiDonNghiPhep } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon, validateMessages } from '../../helpers/common';
import { layChiTiet, luuDonNghiPhep } from '../../services/donnghiphep';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';
import TatCaNhanVienSelectBox from '../utils/TatCaNhanVienSelectBox';

const GiaoCongViec = () => {
    const { TextArea } = Input;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const user = useSelector((state: any) => state.auth.currentUser);
    const menu: any = menuHelper.checkMultiPermission([
        Links.CongViec.Them,
        Links.CongViec.Xem,
        Links.CongViec.GiaoViec
    ]);
    const [form] = useForm();
    const [idCongViec, setIdCongViec] = useState<number>(0);
    const [isLoading, setIsLoading] = useState(false);
    const [confirmModal, setConfirmModal] = useState<any>({});
    function onFinish(values: any) {
        setConfirmModal({
            isShowModal: true,
            title: "Lưu công việc",
            content: <>Bạn có muốn <label>Lưu</label> công việc này không?</>,
            onSubmit: () => { eventSaveCongViec(); }
        });
    }

    const eventSaveCongViec = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen())
            setIsLoading(true);
            try {
                var request = { ...values };
                const id = await luuDonNghiPhep(request);
                toast.success("Lưu công việc thành công");
                navigate(Links.CongViec.Xem + "?id=" + id);
            } catch (error: any) {
                toast.error(error);
            }
            setIsLoading(false);
            dispatch(hideLoadingScreen());
        }).catch((e: any) => {
            toast.error(e);
            dispatch(hideLoadingScreen());
        });
    }

    const disableTuNgay = (current: any) => {
        const denNgay = form.getFieldValue('denNgay');
        return current && current > denNgay;
    }

    const disableDenNgay = (current: any) => {
        const tuNgay = form.getFieldValue('tuNgay');
        return current && current < tuNgay;
    }

    const eventLoadCongViec = async (id: number) => {
        //dispatch(showLoadingScreen());
        //try {
        //    let kq = await layChiTiet(id);
        //    if (kq.trangThai != trangThaiDonNghiPhep.khoiTao && !kq.quyenSua) {
        //        toast.error('Trạng thái không hợp lệ để chỉnh sửa!');
        //        navigate(Links.Phep.DanhSachDangKy);
        //    }
        //    form.setFieldsValue({
        //        id: kq.id,
        //        tuNgay: dayjs(dateCommon.formatDate(kq.tuNgay), "DD/MM/YYYY"),
        //        denNgay: dayjs(dateCommon.formatDate(kq.denNgay), "DD/MM/YYYY"),
        //        kinhGui: kq.kinhGui || "",
        //        lyDo: kq.lyDo || "",
        //        diaDiemNghiPhep: kq.diaDiemNghiPhep || "",
        //        idLoaiNghiPhep: kq.idLoaiNghiPhep,
        //        idNhanViens: (kq.nhanViensLienQuan || []).map(x => x.idNhanVienLienQuan)
        //    });
        //    dispatch(hideLoadingScreen());
        //} catch (err: any) {
        //    toast.error(err);
        //    dispatch(hideLoadingScreen());
        //}
    }

    const eventDeleteCongViec = async () => {
        dispatch(showLoadingScreen());
        try {
            //await xoaKPICaNhan(idCongViec);
            navigate(Links.CongViec.DanhSach);
            toast.success("Xóa công việc thành công");
        }
        catch (e: any) {
            toast.error("Xóa công việc không thành công");
        };

        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let id = +(params.get('id') || '');
        setIdCongViec(+id);
        if (id > 0) {
            eventLoadCongViec(id);
        } else {
            form.setFieldsValue({
                id: 0,
                kinhGui: "",
                lyDo: "",
                diaDiemNghiPhep: "",
                idNhanViens: []
            });
        }
    }, []);

    return (
        <section>
            <ContentHeader title="Chi tiết giao việc" />
            <Form
                layout="vertical"
                onFinish={onFinish}
                onSubmitCapture={(e) => e.preventDefault()}
                validateMessages={validateMessages}
                form={form}
            >
                <Row>
                    <Col span="24">
                        <div className="card-outline">
                            <Tabs
                                tabBarExtraContent={
                                    <Space style={{ position: "fixed", zIndex: 1, right: "25px", top: "120px" }}>
                                        {
                                            menu[Links.CongViec.Them] &&
                                            <Button
                                                loading={isLoading}
                                                type="primary"
                                                icon={<SaveOutlined rev="" />}
                                                htmlType="submit"
                                            >
                                                Lưu
                                            </Button>
                                        }
                                        {
                                            menu[Links.CongViec.Them] && idCongViec > 0 &&
                                            <Button
                                                loading={isLoading}
                                                className="hrm-btn-delete"
                                                icon={<DeleteOutlined rev="" />}
                                                onClick={() => {
                                                    setConfirmModal({
                                                        isShowModal: true,
                                                        title: "Xóa KPI",
                                                        content:
                                                            <>Bạn có muốn <label>Xóa</label> KPI này không?</>,
                                                        onSubmit: eventDeleteCongViec
                                                    });
                                                }}
                                            >
                                                Xóa
                                            </Button>
                                        }
                                    </Space>}
                                defaultActiveKey="1" items={[
                                    {
                                        key: "1",
                                        label: <span>Thông tin</span>,
                                        children:
                                            <Row>
                                                <Col span="24" className="card card-body">
                                                    <Form.Item
                                                        name="id"
                                                        hidden
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Row gutter={24}>
                                                        <Col span={8}>
                                                            <Form.Item
                                                                label="Nhân viên"
                                                                name="idNhanViens"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <TatCaNhanVienSelectBox multiple onChange={(e: any) => {
                                                                    form.setFieldValue('idNhanViens', e.target.value);
                                                                }} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Thời gian giao"
                                                                name="tuNgay"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <DatePicker changeOnBlur={true} disabledDate={disableTuNgay} style={{ width: "100%" }} placeholder="Từ ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col span="8">
                                                            <Form.Item
                                                                label="Thời gian yêu cầu hoàn thành"
                                                                name="denNgay"
                                                                rules={[{ required: true }]}
                                                            >
                                                                <DatePicker changeOnBlur={true} disabledDate={disableDenNgay} style={{ width: "100%" }} placeholder="Đến ngày" format={["DD/MM/YYYY", "DDMMYYYY"]} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col span="24">
                                                            <Form.Item
                                                                label="Nội dung"
                                                                name="noiDung"
                                                                rules={[
                                                                    {
                                                                        required: true
                                                                    }
                                                                ]}
                                                            >
                                                                <TextArea rows={3} />
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                    }
                                ]}
                            />
                        </div>
                    </Col>
                </Row>
            </Form>
            <ModalTextForm
                show={confirmModal.isShowModal}
                title={confirmModal.title}
                handleClose={() => setConfirmModal({ isShowModal: false })}
                handleSave={() => {
                    confirmModal.onSubmit();
                    setConfirmModal({ isShowModal: false });
                }}
            >
                {confirmModal.content}
            </ModalTextForm>
        </section>
    );
};

export default GiaoCongViec;
